import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import './firebase';
import { HashRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import '@/common/style/frame.less';
import { BrowserTracing } from '@sentry/tracing';

import { GlobalContextProvider } from './context';

if (!/debug=true/.test(location.search) && !location.origin.includes('localhost')) {
    Sentry.init({
        dsn: 'https://c708a97532e54ca68ae7e010b4288721@o1241866.ingest.sentry.io/6396077',
        integrations: [new BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

window.name = 'particle-auth-window';
ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <GlobalContextProvider>
                <App />
            </GlobalContextProvider>
        </HashRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
